import router, {
  resetRouter
} from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import tokenStorage from '@/utils/storage/tokenStorage'
import userStorage from '@/utils/storage/userStorage'
import {
  Message
} from 'element-ui'
NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

// 列表页跳转到详情页，返回仍然在列表页固定位置，当前列表页路由的fullpath集合
const HistoryMemoryRoutes = [
  "/IndustryDynamic_list", // 行业资讯
  "/TradeLeads_list", // 供求信息
]

router.beforeEach(async (to, from, next) => {

  // 列表页跳转到详情页，返回仍然在列表页固定位置，设置keepAlive为true
  try {
    let HisBool = HistoryMemoryRoutes.some(item => item == to.fullPath)
    if (HisBool) {
      to.meta.keepAlive = true
    }
  } catch (err) {}


  setRouterEleMinHeight()
  NProgress.start();
  await store.dispatch('theme/aSetGetThemeData')
  if (store.getters.PerfectInformation||store.getters.Ischangepassword=="Y") {
    if (store.getters.token) {
      if (store.getters.rolesName == "个人角色") {
        if (to.path != '/personalInfo') {
          next(`/personalInfo`)
          NProgress.done()
          if(store.getters.Ischangepassword=="Y")
          {
            Message({
              message: "密码较弱，请先修改密码！！",
              type: 'error',
              duration: 2 * 1000
            });
          }
          else{
            Message({
              message: "请先完善基本信息",
              type: 'error',
              duration: 2 * 1000
            });
          }
        }
      }
      if (store.getters.rolesName == "企业用户角色" || store.getters.rolesName == "企业管理员角色") {
        if (to.path != '/EnterpriseInfo') {
          next(`/EnterpriseInfo`)
          NProgress.done()
          if(store.getters.Ischangepassword=="Y")
          {
            Message({
              message: "密码较弱，请先修改密码！！",
              type: 'error',
              duration: 2 * 1000
            });
          }
          else{
            Message({
              message: "请先完善基本信息",
              type: 'error',
              duration: 2 * 1000
            });
          }
        }
      }
    }
  }
  if (!store.getters.hasAuthorized) {
    const accessRoutes = await store.dispatch('permission/aGetRouters')
    resetRouter(router);
    router.addRoutes(accessRoutes)

    next({
      ...to,
      replace: true
    })
  }
  //设置页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  //如果从其他平台跳转过了，需要重新获取用户信息
  if (to.query.usertoken) {
    store.dispatch('user/updateUser', to.query.usertoken)
  }

  if (userStorage.getExternal()) {
    store.dispatch('user/aSetExternal', true)
    if (tokenStorage.getToken()) {
      store.dispatch('user/updateUser', tokenStorage.getToken()).then(() => {})
    }
  } 
  if (to.meta.needAuth) {
    const hasToken = tokenStorage.getToken()
    if (hasToken) {
      async function loginFun() {
        if (to.path === '/login') {
          next({
            path: '/'
          })
          NProgress.done()
        } else {
          if (store.getters.hasAuthorized) {
            // 鉴别菜单权限
            if (to.meta.menuID) {
              const flag = await store.dispatch('permission/aCheckMenuAuth', to.meta.menuID)
              if (!flag) {
                const resstr = await store.dispatch('permission/aGetReviewBindingEnterpriseByUserID');
                if (resstr == "没有申请") {
                  next(`/403`)
                } else if (resstr == "未审核") {
                  next(`/5001`)
                } else if (resstr == "Y") {
                  next(`/5002`)
                } else if (resstr == "N") {
                  next(`/5003`)
                }
              }
            }
            next()
          }
        }
      }
      if (store.getters.external) {
        loginFun()
      } else {
        store.dispatch('user/aGetTokenTime').then(async () => {
          loginFun()
        }).catch(async (res) => {
          loginFun()
        })
      }
    } else {
      if (to.query.usertoken) {
        store.dispatch('user/updateToken', to.query.usertoken)
      } else {
        next(`/login?backurl=${to.path}`)
        NProgress.done()
      }
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  removeRouterEleMinHeight()
  NProgress.done()
})

// 优化footer在页面未加载完成时出现在顶部的问题
function setRouterEleMinHeight() {
  try {
   // document.getElementById("routerEle").setAttribute('style', 'min-height:100vh')
    document.getElementById("routerEle").setAttribute('style', 'min-height:100px')
  } catch (err) {}
}

function removeRouterEleMinHeight() {
  try {
    document.getElementById("routerEle").setAttribute('style', 'min-height:0px')
  } catch (err) {}
}



// WEBPACK FOOTER //
// ./src/permission.js